import { render, staticRenderFns } from "./AccountComponent.vue?vue&type=template&id=33456a77&scoped=true&"
import script from "./AccountComponent.vue?vue&type=script&lang=js&"
export * from "./AccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33456a77",
  null
  
)

export default component.exports